import { memo } from 'react';
import { Modal } from 'Modal';
import { useTranslation } from 'react-i18next';
import { type ProjectGroupMembershipWithProjectGroup } from './ProjectGroup.types';
import './locales/project_group_invitation_modal-en.json';
import { ProjectGroupInvitationPage } from './ProjectGroupInvitationPage';

function ProjectGroupInvitationModalComponent(props: {
    closeModal: () => void;
    isOpen: boolean;
    projectGroupMembership: ProjectGroupMembershipWithProjectGroup;
}) {
    const { closeModal, isOpen, projectGroupMembership } = props;
    const { t } = useTranslation('back_royal');

    if (!isOpen) return null;

    return (
        <Modal
            classNames={{
                base: 'w-[650px] max-w-[90vw]',
                header: 'text-center pb-[10px]',
                body: 'mx-7.5 mb-6',
            }}
            dismissOnEscape={false}
            dismissOnOverlayClick={false}
            hideCloseButton
            onClose={closeModal}
            scrollBehavior="outside"
            title={t('project_group_invitation_modal.title')}
        >
            <ProjectGroupInvitationPage closeModal={closeModal} projectGroupMembership={projectGroupMembership} />
        </Modal>
    );
}

export const ProjectGroupInvitationModal = memo(ProjectGroupInvitationModalComponent);
